export const mailSendText = (state: number | undefined | null) => {
  switch (state) {
    case 1:
      return "대기";
    case 2:
      return "진행중";
    case 3:
      return "완료";
    case 4:
      return "취소";
    case 5:
      return "오류";
    default:
      return "실패";
  }
}